import { createContext, useContext, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/** Lets a page render its own actions into the shell's top bar. */
const SlotContext = createContext<{ el: HTMLElement | null; setEl: (el: HTMLElement | null) => void } | null>(null);

export function TopbarSlotProvider({ children }: { children: ReactNode }) {
  const [el, setEl] = useState<HTMLElement | null>(null);
  return <SlotContext.Provider value={{ el, setEl }}>{children}</SlotContext.Provider>;
}

export function TopbarSlotTarget({ className }: { className?: string }) {
  const ctx = useContext(SlotContext);
  return <div ref={ctx?.setEl} className={className} />;
}

export function TopbarActions({ children }: { children: ReactNode }) {
  const ctx = useContext(SlotContext);
  if (!ctx?.el) return null;
  return createPortal(children, ctx.el);
}
